import { BlackjackApp } from '../blackjack-app';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameMainScene } from 'src/games/common/phaser/game/scenes/game-main-scene';
import { Blackjack } from 'game-logic';

export class BlackjackMainScene extends GameMainScene {
  public static get className(): string {
    return BlackjackMainScene.name;
  }

  constructor(private blackjackApp: BlackjackApp) {
    super({ key: BlackjackMainScene.className, active: false });
  }

  public override showStartButton(showButton: boolean): void {
    this.blackjackApp.sceneController.showStartButton(showButton);
  }

  public override startRound(moves: string[], logicVersion: number): void {
    this.blackjackApp.sceneController.startRemoteRound(moves, logicVersion);
  }

  public override setInstantFinish(): void {
    // Not implemented for this game
  }

  public override autoStartGame(): void {
    this.blackjackApp.sceneController.autoStartGame();
  }

  public override resetGameScene(): void {
    this.blackjackApp.sceneController.resetGameScene();
  }

  public uiButtonTapped(uiButton: Blackjack.UiButtonType): void {
    this.blackjackApp.sceneController.uiButtonTapped(uiButton);
  }

  protected override initGraphics() {
    super.initGraphics();
    this.blackjackApp.sceneController.initGraphics(this);
  }

  protected override onResize(gameSizeMetrics: GameSizeMetrics): void {
    this.blackjackApp.sceneController.onResize(gameSizeMetrics);
  }

  protected override onSceneReady(key: string) {
    super.onSceneReady(key);

    if (key === BlackjackMainScene.className) {
      this.blackjackApp.sceneController.onSceneReady();
    }
  }
}
